export const getMonthName = (month: number | null, currentLanguage: 'en' | 'de') => {
  if (!month) return '';
  const date = new Date(2020, month - 1);
  return date.toLocaleString(currentLanguage, {month: 'long'});
};
